var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { action, runInAction } from 'mobx';
import { runtime } from '../../../classes/runtime/Runtime';
let Video = class Video extends React.PureComponent {
    get isPlaying() {
        const { video } = this.props;
        if (!video.context.app.media.mediaStarter.isAutoPlayPossible)
            return false;
        return video.valueOf.playOnReady === 2 || video.shouldPlayTrigger;
    }
    render() {
        const { video } = this.props;
        if (!runtime.streamedPackages.Defer)
            return null;
        if (!runtime.streamedPackages.Rare)
            return null;
        const { ReactPlayer } = runtime.streamedPackages.Rare.classes;
        return (React.createElement(ReactPlayer, { key: video.id, url: video.vid.src, className: video.essence.aspectClassNames.classNamesAsString, style: { ...video.essence.aspectCss.css }, width: video.essence.aspectCss.css.width, height: video.essence.aspectCss.css.height, playing: this.isPlaying, loop: video.valueOf.videoLoop, controls: !!video.valueOf.videoControls, progressInterval: 200, onReady: action(() => {
                if (video.valueOf.playOnReady >= 1) {
                    video.shouldPlayTrigger = true;
                }
            }), onStart: () => {
                runInAction(() => {
                    video.isPlaying = true;
                });
            }, onPlay: () => {
                runInAction(() => {
                    video.isPlaying = true;
                    video.context.app.appClock.isAppClockPaused = true;
                });
            }, onProgress: ({ played, loaded, loadedSeconds }) => {
                runInAction(() => {
                    video.currentPositionInSeconds = played * video.vid.durationInSeconds;
                    if (runtime.runtimePermissions.hasEditFunctionality) {
                        if (loaded === 1 && !video.vid.durationInSeconds) {
                            video.vid.durationInSeconds = loadedSeconds;
                        }
                    }
                });
            }, onPause: () => {
                runInAction(() => {
                    video.isPlaying = false;
                    video.context.app.appClock.isAppClockPaused = false;
                });
            }, onBuffer: () => { }, onEnded: action(() => {
                video.hasEnded = true;
                video.core.aspectEvents.eventCreation.createAndFireFromRawEvent({ type: 'videoended' });
                video.context.app.appClock.isAppClockPaused = false;
            }), onError: action(() => {
                video.hasError = true;
                video.core.aspectEvents.eventCreation.createAndFireFromRawEvent({ type: 'videoended' });
                video.context.app.appClock.isAppClockPaused = false;
            }) }));
    }
};
Video = __decorate([
    observer
], Video);
export { Video };
